import React from "react";
import styles from "../styles/HomePage.module.css";
import { SEO_METADATA } from "../config/seoMetadata";
import SEO from "../components/SEO";
import HeroSection from "../components/homepage/HeroSection";
import WhyEarTrainingSection from "../components/homepage/WhyEarTrainingSection";
import LearningJourneySection from "../components/homepage/LearningJourneySection";
import FeatureCardsSection from "../components/homepage/FeatureCardsSection";
import HowItWorksSection from "../components/homepage/HowItWorksSection";
import DemoSection from "../components/homepage/DemoSection";
import BenefitsSection from "../components/homepage/BenefitsSection";
import CTASection from "../components/homepage/CTASection";
import Footer from "../components/Footer";

export default function HomePage() {
    return (
        <>
            <SEO {...SEO_METADATA.HOME} />
            <div className={styles.homePage}>
            <HeroSection />
            <WhyEarTrainingSection />
            <LearningJourneySection />
            <FeatureCardsSection />
            <HowItWorksSection />
            <DemoSection />
            <BenefitsSection />
            <CTASection />

            <Footer />
        </div>
        </>
    );
}
